/* Centralised brand assets and constants. */

/* White-bg variant — for light surfaces (navbar on white) */
export const LOGO_LIGHT_URL =
  "https://customer-assets.emergentagent.com/job_elec-biz-platform/artifacts/jzanxl7t_comapny%20log2.jpg";

/* Black-bg variant (transparent-style) — for dark surfaces (footer / sidebar / dark login panel) */
export const LOGO_DARK_URL =
  "https://customer-assets.emergentagent.com/job_elec-biz-platform/artifacts/yr206dp9_comapny%20log2-Photoroom.png";

/* Backwards-compatible alias used in older imports */
export const LOGO_URL = LOGO_LIGHT_URL;

/* Public contact details — used in top header, footer, contact page */
export const COMPANY = {
  name: "UNIVERSAL ELECTRICALS AND ELECTRONICS",
  shortName: "Universal EE",

  /* Primary phone (also used by floating WhatsApp) */
  phone: "+91 84949 00615",
  phoneRaw: "+918494900615",
  whatsapp: "918494900615",

  /* Additional sales line — added Apr 2026 */
  phone2: "+91 96401 27499",
  phone2Raw: "+919640127499",

  email1: "info@ueeindia.com",
  email2: "eande.universal@gmail.com",

  gst: "29AHKPH7026A1ZK",
  founded: "2016",

  /* Backwards-compatible flat address (Unit 1) */
  address:
    "15 & 16, 1st Floor, Girija Arcade, Lakshmipura Main Road, Opp PMK, Abbigere, Bangalore - 560090",

  /* Multi-unit addresses for premium presentation */
  units: [
    {
      label: "Unit 1 — Head Office",
      lines: [
        "UNIVERSAL ELECTRICALS AND ELECTRONICS",
        "15 & 16, 1st Floor, Girija Arcade,",
        "Lakshmipura Main Road,",
        "Opp PMK, Abbigere,",
        "Bangalore - 560090, India",
      ],
      mapQuery:
        "Universal Electricals and Electronics, Girija Arcade, Lakshmipura Main Road, Abbigere, Bengaluru, Karnataka 560090",
    },
    {
      label: "Unit 2",
      lines: [
        "UNIVERSAL ELECTRICALS & ELECTRONICS",
        "Balaji Enclave 11/1, Pipeline Road Kempapura,",
        "Chikkabanavara Kempapura,",
        "Karnataka - 560090, India",
      ],
      mapQuery:
        "Balaji Enclave, Pipeline Road, Kempapura, Chikkabanavara, Bengaluru, Karnataka 560090",
    },
  ],
};

/* 8 hero gallery slides — VERIFIED mining-only stock photos (Pexels) */
export const HERO_GALLERY = [
  {
    image:
      "https://images.pexels.com/photos/31543700/pexels-photo-31543700.jpeg?auto=compress&cs=tinysrgb&w=1920",
    overline: "Heavy Mining Vehicle Safety",
    title: "Every dumper, every shift — protected.",
    subtitle:
      "AFDSS fire suppression, anti-tilt warning, and proximity systems engineered for the world's toughest mining fleets.",
    thumbLabel: "Mining Site · Dump Trucks",
  },
  {
    image:
      "https://images.pexels.com/photos/29506757/pexels-photo-29506757.jpeg?auto=compress&cs=tinysrgb&w=1920",
    overline: "Open-Pit Operations",
    title: "Built for opencast extremes.",
    subtitle:
      "Vehicle-grade electronics that survive vibration, dust, and 50°C ambient — burn-in tested in India for India's mines.",
    thumbLabel: "Open-Pit Mine · Excavators",
  },
  {
    image:
      "https://images.pexels.com/photos/11347699/pexels-photo-11347699.jpeg?auto=compress&cs=tinysrgb&w=1920",
    overline: "HEMM Fleet Coverage",
    title: "Engineered for India's hardest sites.",
    subtitle:
      "From dumpers to shovels and loaders up to 240T class — DGMS-aligned safety devices on every vehicle.",
    thumbLabel: "Aerial · HEMM Fleet",
  },
  {
    image:
      "https://images.pexels.com/photos/10006261/pexels-photo-10006261.jpeg?auto=compress&cs=tinysrgb&w=1920",
    overline: "Field Service Team",
    title: "Trained engineers. 14 mining states.",
    subtitle:
      "Field engineers, NABL-traceable calibration kits, and a 4-hour SLA at every major coal belt.",
    thumbLabel: "Field Engineer · Komatsu Truck",
  },
  {
    image:
      "https://images.pexels.com/photos/14704783/pexels-photo-14704783.jpeg?auto=compress&cs=tinysrgb&w=1920",
    overline: "Anti-Collision & Proximity",
    title: "Zero blind spots. Zero excuses.",
    subtitle:
      "UWB-based Proximity Warning, 77 GHz radar, and 360° camera systems that prevent man-machine collisions on opencast benches.",
    thumbLabel: "Mining Haul Road",
  },
  {
    image:
      "https://images.pexels.com/photos/14484386/pexels-photo-14484386.jpeg?auto=compress&cs=tinysrgb&w=1920",
    overline: "Fire Suppression Systems",
    title: "Detect. Suppress. Survive.",
    subtitle:
      "DGMS-compliant Automatic Fire Detection & Suppression Systems for HEMM dumpers, excavators, and loaders.",
    thumbLabel: "Mining Truck · AFDSS",
  },
  {
    image:
      "https://images.pexels.com/photos/15325401/pexels-photo-15325401.jpeg?auto=compress&cs=tinysrgb&w=1920",
    overline: "Driver Alert & Fatigue",
    title: "Operators safe — fleet productive.",
    subtitle:
      "AI fatigue detection, seat-belt reminders, distraction monitors, and speed limiters built for 12-hour mining shifts.",
    thumbLabel: "Heavy Dump Truck · Worksite",
  },
  {
    image:
      "https://images.pexels.com/photos/9529407/pexels-photo-9529407.jpeg?auto=compress&cs=tinysrgb&w=1920",
    overline: "Camera Monitoring & MDVR",
    title: "Installed, tested, and certified.",
    subtitle:
      "Each camera & MDVR commissioned with branded service reports — signed by the field engineer and the customer.",
    thumbLabel: "Mining Truck · Camera Setup",
  },
];
